(() => {
    useReportsNavFactory.$inject = ['$state', '$filter', 'hUser', 'reportsPrerequisiteService'];

    function useReportsNavFactory($state, $filter, hUser, reportsPrerequisiteService) {
        return function ($scope, isActiveLink, getBrandIds) {

            const reportsNavItemsCodes = {
                DAR: 'DAR',
                FLASH_DASH_REPORT: 'FLASH_DASH_REPORT',
                FLASH_REPORT_V2: 'FLASH_REPORT_V2',
            }

            const reportsNav = [
                {
                    classNames: 'sb-main-items-container',
                    search: {
                        enabled: true,
                        showInput: false,
                        term: ''
                    },
                    isVisible: async () => {
                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                        const teamLiveBrandsList = await GatewayTeamLiveAPI.getBrandsSettingsV3(hUser.getUserContext().brand_id, {brand_ids: [activeBrandId]});
                        const brandSettings = teamLiveBrandsList.find((brand) => {
                            return brand.id === activeBrandId;
                        });
                        await reportsPrerequisiteService.iniReportsPrerequisite(brandSettings);
                        return reportsPrerequisiteService.checkReportsMenuVisibility(activeBrandId);
                    },
                    sortable: true,
                    title: $filter('translate')('Reports'),
                    sections: [
                        {
                            title: $filter('translate')('HR'),
                            sortable: true,
                            items: [
                                {
                                    title: $filter('translate')('Attendance reliability report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/hr.svg',
                                        filledSvg: '../images/svgs/hr_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.attendance-reliability-report'),
                                    href: () => $state.href('appLayout.schedule.reports.attendance-reliability-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkAttendanceReliabilityVisibility(activeBrandId);
                                    }
                                },
                                {
                                    title: $filter('translate')('Consent reports'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/hr.svg',
                                        filledSvg: '../images/svgs/hr_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.consent-report'),
                                    href: () => $state.href('appLayout.schedule.reports.consent-report'),
                                    isVisible: async () => {
                                        return reportsPrerequisiteService.checkConsentReportsVisibility(hUser.getActiveBrandIdWithAccess())
                                    }
                                },
                                {
                                    title: $filter('translate')('Availability report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/hr.svg',
                                        filledSvg: '../images/svgs/hr_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.availability'),
                                    href: () => $state.href('appLayout.schedule.reports.availability'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkAvailabilityReportVisibility(activeBrandId)
                                    }
                                },
                                {
                                    title: $filter('translate')('Employee roster'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/hr.svg',
                                        filledSvg: '../images/svgs/hr_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.employee-roster'),
                                    href: () => $state.href('appLayout.schedule.reports.employee-roster'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkEmployeeRostertVisibility(activeBrandId)
                                    }
                                },
                                {
                                    title: $filter('translate')('Absence tracker report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/hr.svg',
                                        filledSvg: '../images/svgs/hr_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.absence-tracker-report'),
                                    href: () => $state.href('appLayout.schedule.reports.absence-tracker-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkAbsenceTrackerVisibility(activeBrandId)
                                    }
                                },
                                {
                                    title: $filter('translate')('Unemployment claims report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/hr.svg',
                                        filledSvg: '../images/svgs/hr_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.unemployment-claims-report'),
                                    href: () => $state.href('appLayout.schedule.reports.unemployment-claims-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkUnemploymentClaimsReportVisibility(activeBrandId);
                                    }
                                },
                                {
                                    title: $filter('translate')('Employee turnover report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/hr.svg',
                                        filledSvg: '../images/svgs/hr_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.turnover-report'),
                                    href: () => $state.href('appLayout.schedule.reports.turnover-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkTurnoverReportVisibility(activeBrandId)
                                    }
                                },
                                {
                                    title: $filter('translate')('Clock-in message'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/hr.svg',
                                        filledSvg: '../images/svgs/hr_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.clock-in-message-report'),
                                    href: () => $state.href('appLayout.schedule.reports.clock-in-message-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkClockInMessageVisibility(activeBrandId)
                                    }
                                },
                                {
                                    title: $filter('translate')('Employee detailed satisfaction report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/hr.svg',
                                        filledSvg: '../images/svgs/hr_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.employee-detailed-satisfaction-report'),
                                    href: () => $state.href('appLayout.schedule.reports.employee-detailed-satisfaction-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkEmployeeDetailedSatisfactionReportVisibility(activeBrandId)
                                    }
                                },
                                {
                                    title: $filter('translate')('Employee edits report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/hr.svg',
                                        filledSvg: '../images/svgs/hr_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.employee-edits-report'),
                                    href: () => $state.href('appLayout.schedule.reports.employee-edits-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkEmployeeEditsReportVisibility(activeBrandId)
                                    }
                                },
                                {
                                    title: $filter('translate')('Employee health check report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/hr.svg',
                                        filledSvg: '../images/svgs/hr_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.covid-19-employees-report'),
                                    href: () => $state.href('appLayout.schedule.reports.covid-19-employees-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkEmployeeHealthCheckReportVisibility(activeBrandId)
                                    }
                                },
                                {
                                    title: $filter('translate')('GFE documents tracking report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/hr.svg',
                                        filledSvg: '../images/svgs/hr_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.gfe-documents-tracking-report'),
                                    href: () => $state.href('appLayout.schedule.reports.gfe-documents-tracking-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkGFEDocumentTrackingVisibility(activeBrandId)
                                    }
                                },
                                {
                                    title: $filter('translate')('Health check summary report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/hr.svg',
                                        filledSvg: '../images/svgs/hr_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.employee-health-check-report'),
                                    href: () => $state.href('appLayout.schedule.reports.employee-health-check-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkHealthCheckSummaryReportVisibility(activeBrandId)
                                    }
                                },
                                {
                                    title: $filter('translate')('Holiday allowance report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/hr.svg',
                                        filledSvg: '../images/svgs/hr_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.holiday-allowance'),
                                    href: () => $state.href('appLayout.schedule.reports.holiday-allowance'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkHolidayAllowanceReportVisibility(activeBrandId)
                                    }
                                },
                                {
                                    title: $filter('translate')('Team member master report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/hr.svg',
                                        filledSvg: '../images/svgs/hr_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.team-member-master-report'),
                                    href: () => $state.href('appLayout.schedule.reports.team-member-master-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkTeamMemberMasterReportVisibility(activeBrandId)
                                    }
                                },
                            ]
                        },
                        {
                            title: $filter('translate')('Timekeeping'),
                            sortable: true,
                            items: [
                                {
                                    title: $filter("translate")('Daily activity report') + ' (DAR)',
                                    code: reportsNavItemsCodes.DAR,
                                    icon: {
                                        unfilledSvg: '../images/svgs/time_keeping.svg',
                                        filledSvg: '../images/svgs/time_keeping_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.daily-activity-report'),
                                    href: () => $state.href('appLayout.schedule.reports.daily-activity-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkDARVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Pay period report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/time_keeping.svg',
                                        filledSvg: '../images/svgs/time_keeping_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.pay-period-report'),
                                    href: () => $state.href('appLayout.schedule.reports.pay-period-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkPayPeriodReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter("translate")('Labor analysis report') + ' (LAB)',
                                    icon: {
                                        unfilledSvg: '../images/svgs/time_keeping.svg',
                                        filledSvg: '../images/svgs/time_keeping_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.labor-analysis-report'),
                                    href: () => $state.href('appLayout.schedule.reports.labor-analysis-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkLaborAnalysisReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter("translate")('Punch reports'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/time_keeping.svg',
                                        filledSvg: '../images/svgs/time_keeping_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.punch-reports'),
                                    href: () => $state.href('appLayout.schedule.reports.punch-reports'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkPunchReportsVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter("translate")('Labor exception report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/time_keeping.svg',
                                        filledSvg: '../images/svgs/time_keeping_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.labor-exception-report'),
                                    href: () => $state.href('appLayout.schedule.reports.labor-exception-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkLaborExceptionReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Approaching weekly OT report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/time_keeping.svg',
                                        filledSvg: '../images/svgs/time_keeping_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.overtime-report'),
                                    href: () => $state.href('appLayout.schedule.reports.overtime-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkApproachingWeeklyOTReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Breaks report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/time_keeping.svg',
                                        filledSvg: '../images/svgs/time_keeping_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.scheduled-breaks-report'),
                                    href: () => $state.href('appLayout.schedule.reports.scheduled-breaks-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkBreaksReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('FWW premiums report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/time_keeping.svg',
                                        filledSvg: '../images/svgs/time_keeping_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.premium-report'),
                                    href: () => $state.href('appLayout.schedule.reports.premium-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkFWWPremiumsReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Missed breaks report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/time_keeping.svg',
                                        filledSvg: '../images/svgs/time_keeping_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.missed-breaks'),
                                    href: () => $state.href('appLayout.schedule.reports.missed-breaks'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkMissedBreaksReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Forecast accuracy report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/time_keeping.svg',
                                        filledSvg: '../images/svgs/time_keeping_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.forecast-accuracy-report'),
                                    href: () => $state.href('appLayout.schedule.reports.forecast-accuracy-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkForecastAccuracyReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Punch detail report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/time_keeping.svg',
                                        filledSvg: '../images/svgs/time_keeping_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.punch-detail-report'),
                                    href: () => $state.href('appLayout.schedule.reports.punch-detail-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkPunchDetailReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Punch photos exceptions report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/time_keeping.svg',
                                        filledSvg: '../images/svgs/time_keeping_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.punch-photos-exceptions-report'),
                                    href: () => $state.href('appLayout.schedule.reports.punch-photos-exceptions-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkPunchPhotosExceptionsReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Time card edits report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/time_keeping.svg',
                                        filledSvg: '../images/svgs/time_keeping_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.time-card-edits-report'),
                                    href: () => $state.href('appLayout.schedule.reports.time-card-edits-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkTimeCardEditsReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Timesheet report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/time_keeping.svg',
                                        filledSvg: '../images/svgs/time_keeping_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.time-sheet-report'),
                                    href: () => $state.href('appLayout.schedule.reports.time-sheet-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkTimeSheetReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Wage type summary'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/time_keeping.svg',
                                        filledSvg: '../images/svgs/time_keeping_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.wage-type-summary-report'),
                                    href: () => $state.href('appLayout.schedule.reports.wage-type-summary-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkWageTypeSummaryReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('No pay report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/time_keeping.svg',
                                        filledSvg: '../images/svgs/time_keeping_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.no-pay-report'),
                                    href: () => $state.href('appLayout.schedule.reports.no-pay-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkNoPayReportVisibility(activeBrandId)
                                    },
                                },
                            ]
                        },
                        {
                            title: $filter('translate')('Scheduling'),
                            sortable: true,
                            items: [
                                {
                                    title: $filter("translate")('Daily crew schedule') + ' (' + $filter('translate')('line bar') + ')',
                                    icon: {
                                        unfilledSvg: '../images/svgs/scheduling.svg',
                                        filledSvg: '../images/svgs/scheduling_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.daily-crew-schedule-report'),
                                    href: () => $state.href('appLayout.schedule.reports.daily-crew-schedule-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkDailyCrewScheduleReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Schedule change report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/scheduling.svg',
                                        filledSvg: '../images/svgs/scheduling_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.schedule-change-report'),
                                    href: () => $state.href('appLayout.schedule.reports.schedule-change-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkScheduleChangeReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Weekly schedule report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/scheduling.svg',
                                        filledSvg: '../images/svgs/scheduling_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.weekly-schedule-report'),
                                    href: () => $state.href('appLayout.schedule.reports.weekly-schedule-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkWeeklyScheduleReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Available shifts report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/scheduling.svg',
                                        filledSvg: '../images/svgs/scheduling_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.available-shifts'),
                                    href: () => $state.href('appLayout.schedule.reports.available-shifts'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkAvailableShiftsReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Detailed employee labour report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/scheduling.svg',
                                        filledSvg: '../images/svgs/scheduling_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.detailed-employee-labor-report'),
                                    href: () => $state.href('appLayout.schedule.reports.detailed-employee-labor-report'),
                                    gettitle: () => {
                                        if (['US', 'PH'].indexOf(activeBrandCountryCode) === -1) {
                                            return $filter("translate")('Detailed employee labour report');
                                        } else {
                                            return $filter("translate")('Detailed employee labor report');
                                        }
                                    },
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkDetailedEmployeeLaborReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Employee labour variance report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/scheduling.svg',
                                        filledSvg: '../images/svgs/scheduling_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.employee-labor-variance-report'),
                                    href: () => $state.href('appLayout.schedule.reports.employee-labor-variance-report'),
                                    gettitle: () => {
                                        if (['US', 'PH'].indexOf(activeBrandCountryCode) === -1) {
                                            return $filter("translate")('Employee labour variance report')
                                        } else {
                                            return $filter("translate")('Employee labor variance report')
                                        }
                                    },
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkEmployeeLaborVarianceReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Flash dash report'),
                                    code: reportsNavItemsCodes.FLASH_DASH_REPORT,
                                    icon: {
                                        unfilledSvg: '../images/svgs/scheduling.svg',
                                        filledSvg: '../images/svgs/scheduling_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.enterprise-flash-report'),
                                    href: () => $state.href('appLayout.schedule.reports.enterprise-flash-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkEnterpriseFlashReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Flash report v2'),
                                    code: reportsNavItemsCodes.FLASH_REPORT_V2,
                                    icon: {
                                        unfilledSvg: '../images/svgs/scheduling.svg',
                                        filledSvg: '../images/svgs/scheduling_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.flash-report-v2'),
                                    href: () => $state.href('appLayout.schedule.reports.flash-report-v2'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkFlashReportV2Visibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Labour variance report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/scheduling.svg',
                                        filledSvg: '../images/svgs/scheduling_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.labor-variance-report'),
                                    href: () => $state.href('appLayout.schedule.reports.labor-variance-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        const teamLiveBrandsList = await GatewayTeamLiveAPI.getBrandsSettingsV3(hUser.getUserContext().brand_id, {brand_ids: [activeBrandId]});
                                        const brandSettings = teamLiveBrandsList.find((brand) => {
                                            return brand.id === activeBrandId;
                                        });
                                        return (
                                            ['US', 'PH'].indexOf(brandSettings?.team_live_country_code) === -1 &&
                                            reportsPrerequisiteService.checkLaborVarianceReportVisibility(activeBrandId)
                                        );
                                    },
                                },
                                {
                                    title: $filter('translate')('Labor variance report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/scheduling.svg',
                                        filledSvg: '../images/svgs/scheduling_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.labor-variance-report'),
                                    href: () => $state.href('appLayout.schedule.reports.labor-variance-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        const teamLiveBrandsList = await GatewayTeamLiveAPI.getBrandsSettingsV3(hUser.getUserContext().brand_id, {brand_ids: [activeBrandId]});
                                        const brandSettings = teamLiveBrandsList.find((brand) => {
                                            return brand.id === activeBrandId;
                                        });
                                        return (
                                            ['US', 'PH'].indexOf(brandSettings?.team_live_country_code) > -1 &&
                                            reportsPrerequisiteService.checkLaborVarianceReportVisibility(activeBrandId)
                                        );
                                    },
                                },
                                {
                                    title: $filter('translate')('Logbook checklists report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/scheduling.svg',
                                        filledSvg: '../images/svgs/scheduling_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.logbook-checklists-report'),
                                    href: () => $state.href('appLayout.schedule.reports.logbook-checklists-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkLogbookChecklistsReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Logbook entries report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/scheduling.svg',
                                        filledSvg: '../images/svgs/scheduling_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.logbook-entries-report'),
                                    href: () => $state.href('appLayout.schedule.reports.logbook-entries-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkLogbookEntriesReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Logbook tasks report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/scheduling.svg',
                                        filledSvg: '../images/svgs/scheduling_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.logbook-tasks-report'),
                                    href: () => $state.href('appLayout.schedule.reports.logbook-tasks-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkLogbookTasksReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Needed hours'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/scheduling.svg',
                                        filledSvg: '../images/svgs/scheduling_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.needed-hours-report'),
                                    href: () => $state.href('appLayout.schedule.reports.needed-hours-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkNeededHoursReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Schedule audit report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/scheduling.svg',
                                        filledSvg: '../images/svgs/scheduling_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.schedule-audit-report'),
                                    href: () => $state.href('appLayout.schedule.reports.schedule-audit-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkScheduleAuditReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Scheduling status report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/scheduling.svg',
                                        filledSvg: '../images/svgs/scheduling_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.scheduling-status'),
                                    href: () => $state.href('appLayout.schedule.reports.scheduling-status'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkScheduleStatusReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Unscheduled employee report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/scheduling.svg',
                                        filledSvg: '../images/svgs/scheduling_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.unscheduled-employee-report'),
                                    href: () => $state.href('appLayout.schedule.reports.unscheduled-employee-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkUnscheduledEmployeeReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Schedule creation metrics report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/scheduling.svg',
                                        filledSvg: '../images/svgs/scheduling_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.schedule-creation-metric'),
                                    href: () => $state.href('appLayout.schedule.reports.schedule-creation-metric'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkMetricsReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Regular schedule variations report'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/scheduling.svg',
                                        filledSvg: '../images/svgs/scheduling_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.regular-schedule-variation-report'),
                                    href: () => $state.href('appLayout.schedule.reports.regular-schedule-variation-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkRegularScheduleVariationsReportVisibility(activeBrandId)
                                    },
                                },
                            ]
                        },
                        {
                            title: $filter('translate')('Integrations'),
                            sortable: true,
                            items: [
                                {
                                    title: $filter('translate')('McD integration rejection reports'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/integration.svg',
                                        filledSvg: '../images/svgs/integration_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.integration-rejection-report'),
                                    href: () => $state.href('appLayout.schedule.reports.integration-rejection-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkIntegrationRejectionReportsVisibility(activeBrandId);
                                    },
                                },
                                {
                                    title: $filter('translate')('ADP employee sync status'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/integration.svg',
                                        filledSvg: '../images/svgs/integration_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.adp-employee-sync-status-report'),
                                    href: () => $state.href('appLayout.schedule.reports.adp-employee-sync-status-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkAdpEmployeeSyncReportVisibility(activeBrandId);
                                    },
                                },
                            ]
                        },
                        {
                            title: $filter('translate')('Harri engage'),
                            sortable: true,
                            items: [
                                {
                                    title: $filter('translate')('Engagement ratings report'),
                                    icon: {
                                        filledSvg: '../images/svgs/onboarding_journey.svg',
                                        unfilledSvg: '../images/svgs/onboarding_journey_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.engagement-ratings-report'),
                                    href: () => $state.href('appLayout.schedule.reports.engagement-ratings-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkPollEventsReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Engagement non-ratings report'),
                                    icon: {
                                        filledSvg: '../images/svgs/onboarding_journey.svg',
                                        unfilledSvg: '../images/svgs/onboarding_journey_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.schedule.reports.engagement-non-ratings-report'),
                                    href: () => $state.href('appLayout.schedule.reports.engagement-non-ratings-report'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        return reportsPrerequisiteService.checkOnboardingJourneyEventsReportVisibility(activeBrandId)
                                    },
                                },
                                {
                                    title: $filter('translate')('Employee engagement surveys'),
                                    icon: {
                                        filledSvg: '../images/svgs/onboarding_journey.svg',
                                        unfilledSvg: '../images/svgs/onboarding_journey_filled.svg'
                                    },
                                    isActive: () => $state.is('appLayout.harriSH.surveys', {
                                        reportSlug: '/surveys-report',
                                    }),
                                    href: () => $state.href('appLayout.harriSH.surveys', {
                                        reportSlug: '/surveys-report',
                                    }),
                                    isVisible: async () => {
                                        return reportsPrerequisiteService.checkEngagementSurveysReportVisibility(hUser.getActiveBrandIdWithAccess());
                                    },
                                },
                                {
                                    title: $filter('translate')('Engagement ratings report'),
                                    icon: {
                                        filledSvg: '../images/svgs/onboarding_journey.svg',
                                        unfilledSvg: '../images/svgs/onboarding_journey_filled.svg'
                                    },
                                    isActive: () => $state.is('appLayout.harriSH.engagement-ratings', {
                                        reportSlug: '/engagement-ratings',
                                    }),
                                    href: () => $state.href('appLayout.harriSH.engagement-ratings', {
                                        reportSlug: '/engagement-ratings',
                                    }),
                                    isVisible: async () => {
                                        return reportsPrerequisiteService.checkEngagementRatingsReportVisibility(hUser.getActiveBrandIdWithAccess());
                                    },
                                },
                                {
                                    title: $filter('translate')('Engagement non-ratings report'),
                                    icon: {
                                        filledSvg: '../images/svgs/onboarding_journey.svg',
                                        unfilledSvg: '../images/svgs/onboarding_journey_filled.svg'
                                    },
                                    isActive: () => $state.is('appLayout.harriSH.engagement-non-ratings', {
                                        reportSlug: '/engagement-non-ratings',
                                    }),
                                    href: () => $state.href('appLayout.harriSH.engagement-non-ratings', {
                                        reportSlug: '/engagement-non-ratings',
                                    }),
                                    isVisible: async () => {
                                        return reportsPrerequisiteService.checkEngagementNoneRatingsReportVisibility(hUser.getActiveBrandIdWithAccess());
                                    },
                                },
                            ]
                        }
                    ]
                }];

            return {
                reportsNav,
                reportsNavItemsCodes
            }
        }
    }

    angular
        .module("harriApp")
        .factory('useReportsNavFactory', useReportsNavFactory);
})();